// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_fK","catalogByServiceItem__title":"c-l_fL"};